import mixpanelProvider from '../../providers/mixpanel';

export const ENUM_EVENTS = {
  USER_CHANGED_PAGE: 'User Changed Page',
  SET_ORDER_STATUS_TO_SENT_WITHOUT_SENDING_IT: 'Set order status to sent without sending it”',
  VALIDATE_FORECAST: 'Validate forecast',
  SEND_ORDER: 'Send order',
  PREFILL_ORDER_FORM: 'Prefill order form',
  HELP_CENTER: 'User clicked on Help Center',
  REFERRAL: 'User clicked on Referral',
  DOWNLOAD_INVENTORY_SHEET: 'User download inventory sheet',
  OPEN_AUDIT_LOG_SIDE_PANEL: 'User opened audit log side panel',
  RELAUNCH_ANALYTICS: '[Analytics] User clicked on the analytics relaunch action',
  RELAUNCH_ANALYTICS_WITH_ACTUAL_RECIPE_COMPOSITION:
    '[Analytics] User relaunched analytics with an actual recipe composition',
  // Supplier products
  UPDATE_SUPPLIER_PRODUCT_PRICE_FROM_ORDER_RECEIPT:
    'Update supplierProduct price from order receipt',
  IMPORT_SUPPLIER_PRODUCT_BATCH_CREATION_FILE: 'User uploaded a bulk creation file',
  IMPORT_SUPPLIER_PRODUCT_BATCH_MODIFICATION_FILE: 'User uploaded a bulk modification file',
  // Storage areas
  CREATE_STORAGE_AREA: 'User created a storage area',
  UPDATE_STORAGE_AREA: 'User edited a storage area',
  // Recipe variants
  CREATE_RECIPE_VARIANT: 'User created a recipe variant',
  UPDATE_RECIPE_VARIANT: 'User edited a recipe variant',
  // Buffer stocks
  UPDATE_BUFFER_STOCK: 'User updated a buffer stock',
  // Inventory template
  CREATE_INVENTORY_TEMPLATE: 'User created an inventory template',
  UPDATE_INVENTORY_TEMPLATE: 'User edited an inventory template',
};

/**
 * Sent as the `source` property of events that can be triggered from several entry points
 */
export const ENUM_EVENT_SOURCES = {
  DETAILS: 'details',
  CREATION_FORM: 'creation_form',
  LIST_SELECTION: 'list_selection',
  CLONE: 'clone',
  STORE_DETAILS: 'store_details',
  RECIPE_DETAILS: 'recipe_details',
  SUPPLIER_PRODUCT_DETAILS: 'supplier_product_details',
  BATCH_MODIFICATION_FILE: 'batch_modification_file',
};

export const sendMetric = (event, properties = {}) => {
  const mixPanel = mixpanelProvider.getInstance();

  mixPanel.track(event, properties);
};

export default {
  sendMetric,
  ENUM_EVENTS,
};
